import { useAppData } from 'src/app/data';
import {
  getEnv,
  PipelinesEnvEnum,
} from 'src/components/pipelines/utils/env-base-url';

import PipelinesEnvIndicator from './env-indicator';

export default () => {
  const { user } = useAppData();
  const env = getEnv();

  if (
    !user ||
    !user.isAtlassian ||
    !env ||
    !(Object.values(PipelinesEnvEnum) as string[]).includes(env)
  ) {
    return null;
  }

  return <PipelinesEnvIndicator env={env} />;
};
